import { USER_PROFILE_LIST_COLUMN } from "./actionTypes";

// List User Profile
export const setListUserProfileColumn = (field, value) => ({
  type: USER_PROFILE_LIST_COLUMN,
  payload: { field, value },
});
